import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ResetPassordService } from '../../services';

export const fetchResetPasword = createAsyncThunk(
    'resetPassword/fetchResetPasword',
    async ({ mail }) => {
        const response = await ResetPassordService(mail)
        return response.result
    }
);

const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState: {
        resetPassword: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchResetPasword.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchResetPasword.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.resetPassword = action.payload;
            })
            .addCase(fetchResetPasword.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default resetPasswordSlice.reducer;
